module.exports = __webpack_public_path__ + "static/aristas-logo-aba5a6ba4f80e5f751948902a426a174.png";